import { render, staticRenderFns } from "./NavigationDrawerConfiguracaoSistema.vue?vue&type=template&id=53f9fc00&"
import script from "./NavigationDrawerConfiguracaoSistema.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerConfiguracaoSistema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports